/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ArtistInputs */

const en_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artist Name`)
};

const es_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del artista`)
};

const fr_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l'artiste`)
};

const de_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Künstlers`)
};

const ja_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーティスト名`)
};

const zh_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`艺术家姓名`)
};

const ar_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم الفنان`)
};

const id_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Seniman`)
};

const it_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dell'Artista`)
};

const ru_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя художника/автора`)
};

const pt_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do Artista`)
};

const ko_field_artist = /** @type {(inputs: Field_ArtistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아티스트 이름`)
};

/**
* | output |
* | --- |
* | "Artist Name" |
*
* @param {Field_ArtistInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_artist = /** @type {((inputs?: Field_ArtistInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ArtistInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_artist(inputs)
	if (locale === "es") return es_field_artist(inputs)
	if (locale === "fr") return fr_field_artist(inputs)
	if (locale === "de") return de_field_artist(inputs)
	if (locale === "ja") return ja_field_artist(inputs)
	if (locale === "zh") return zh_field_artist(inputs)
	if (locale === "ar") return ar_field_artist(inputs)
	if (locale === "id") return id_field_artist(inputs)
	if (locale === "it") return it_field_artist(inputs)
	if (locale === "ru") return ru_field_artist(inputs)
	if (locale === "pt") return pt_field_artist(inputs)
	return ko_field_artist(inputs)
});